import { render, staticRenderFns } from "./SdsOrderItems.vue?vue&type=template&id=744d273e&"
import script from "./SdsOrderItems.vue?vue&type=script&lang=js&"
export * from "./SdsOrderItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports